import React, { useEffect, useState } from 'react';
import { dispatchService } from '../../services/central-api/dispatch';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { useAuth } from '../../context/Auth';

type SetStateCallback<S> = ((prevState: S) => S);

interface Props {
    value: number[];
    setValue: React.Dispatch<SetStateCallback<number[]>>;
    zIndex?: number;
    disabled?: boolean;
    labelFontSize?: number;
    label?: string;
    actingBodyId: number;
}

export default function FinishReasonDropdown({ value, setValue, zIndex, disabled, labelFontSize, label, actingBodyId }: Props) {
    const { user: authenticatedUser } = useAuth();
    const [finishCategories, setFinishCategories] = useState<DropdownResource[]>([]);

    async function loadPageInfo () {
        if (actingBodyId === 0) {
            setFinishCategories([]);
            return;
        }

        const finishCategories = await dispatchService.getSimplifiedFinishReasons(actingBodyId);
        setFinishCategories(finishCategories);
    }

    useEffect(() => {
        if (!authenticatedUser) {
            return;
        }
        loadPageInfo();
    }, [actingBodyId, authenticatedUser]);

    return (
        <FilterDropdown
            label={label ?? translate('finishReason')}
            items={finishCategories.map(finishCategory => ({
                label: finishCategory.name,
                value: finishCategory.id
            }))}
            multiple={true}
            mode="BADGE"
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            disabled={disabled}
            labelFontSize={labelFontSize}
        />
    );
}
